let fallbackSearchOriginId = 0;
function createSearchOriginId() {
    return "u" > typeof crypto && 'function' == typeof crypto.randomUUID ? crypto.randomUUID() : `search-origin-${Date.now()}-${fallbackSearchOriginId++}`;
}
export { createSearchOriginId };
